export default {
  name: "Content-Type",
  in: "query",
  required: true,
  description: "Content type",
  schema: {
    type: "string",
    example: "Content-Type: application/json"
  }
};
